<template>
  <div>
    <section-title
      content="Inventarios o pruebas que utilizan la tipología y fue administrado al evaluado:"
      has-line
    />

    <div class="px-3 mb-3">
      <div class="row">
        <div
          v-for="item in items"
          :key="item.id"
          class="my-3 d-flex align-items-center"
          :class="{ 'col-md-4': !isOther(item), 'col-md': isOther(item) }"
        >
          <div>
            <check-box
              class="mr-2 checkbox"
              disabled
              :text="item.name"
              :value="item.checked"
            />
          </div>

          <div
            v-if="isOther(item) && item.checked && !isReadOnly"
            class="w-100"
          >
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-input
                v-model="item.other"
                custom-error-msg="El campo es requerido."
                disabled
                :error="errors[0]"
              />
            </validation-provider>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from '@/shared/components/SectionTitle.vue';
import CheckBox from 'CheckBox';
import CustomInput from 'CustomInput';

const otherId = 14;

export default {
  name: 'Inventories',
  components: { SectionTitle, CheckBox, CustomInput },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    model: {
      get() {
        return this.value || [];
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    isOther() {
      return (item) => item.id == otherId;
    },
    items() {
      if (this.isReadOnly) {
        const checks = this.value.filter((i) => i.checked);
        const other = checks.find((i) => i.id === otherId);
        if (other?.other) other.name = other.other;
        return checks;
      }

      return this.model;
    },
  },
};
</script>

<style scoped>
.mr-2 {
  margin-right: 0.5rem;
}
.flex-grow-1 {
  flex-grow: 1;
}

::v-deep .input-group .option-input:checked:disabled + label span {
  background-color: #3f5b60 !important;
}
::v-deep .input-group .option-input:checked:disabled + label span .ic-check {
  background-image: url('../../../../../../../../assets/img/white-check.svg') !important;
  background-size: 70% !important;
  background-repeat: no-repeat;
  background-position: center;
}
</style>
